export default {
    loading: "Betöltés"
}